import httpHelper from "../helpers/httpHelper";

const CONTROLLER = "/Storage/File";
const fileApi = {
    GetUploadUrl(data) {
        return httpHelper.get(CONTROLLER + "/GetUploadUrl", data);
    },
    InsertFile(data) {
        return httpHelper.get(CONTROLLER + "/InsertFile", data);
    },
    List(data) {
        return httpHelper.get(CONTROLLER + "/List", data);
    },
    AddYoutube(data) {
        return httpHelper.post(CONTROLLER + "/AddYoutube", data);
    },
    Delete(data) {
        return httpHelper.delete(CONTROLLER + "/Delete", data);
    },
    GetLibrarySize(data) {
        return httpHelper.get(CONTROLLER + "/GetLibrarySize", data);
    },
    List_Client(data) {
        return httpHelper.get(CONTROLLER + "/List_Client", data);
    },
    Edit(data) {
        return httpHelper.put(CONTROLLER + "/Edit", data);
    },
    Get(data) {
        return httpHelper.get(CONTROLLER + "/Get", data);
    },
    GetShareFile(data) {
        return httpHelper.get(CONTROLLER + "/GetShareFile", data);
    },
    ShareFile(data) {
        return httpHelper.put(CONTROLLER + "/ShareFile", data);
    },

}

export default fileApi;
